<template>
    <div class="row">
        <div class="col-5 p-5">
            <div class="listTitle p-2">REM3RCH UPDATES</div>
            <div v-for="versioning in getVersioningsCurrent" class="content-versioning-update">
                <div class="listTitle">{{ versioning.version }} - {{ versioning.name.toUpperCase() }}</div>
                <p class="p-3" v-html-safe="nl2br(versioning.description)"><!-- {{nl2br(versioning.description)}} --></p>
                <p class="content-date">RELEASE DATE {{ versioning.versioningDate }}</p>
            </div>
        </div>
        <div class="col-1"></div>
        <div class="col-5 p-3">
            <div class="listTitle">UPCOMING UPDATES</div>
            <div class="content-versioning-upcoming" v-for="versioning in getVersioningsUpcoming">
                <div class="listTitle">{{ versioning.name.toUpperCase() }}</div>
                <p class="p-3 content-description" v-html-safe="nl2br(versioning.description)"><!-- {{nl2br(versioning.description)}} --></p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
    name: "versionings",
    data() {
        return {};
    },
    computed: {
        ...mapGetters("versioning", {
            getVersioningsUpcoming: "getVersioningsUpcoming",
            getVersioningsCurrent: "getVersioningsCurrent"
        })
    },
    created() {
        this.findAllVersionings();
    },
    mounted() {},
    methods: {
        ...mapActions("versioning", {
            findAllVersionings: "findAllVersionings"
        })
    }
};
</script>

<style scoped lang="scss">
.content-versioning-update {
    background-color: #e9f3e3;
    padding: 6px;
    margin-bottom: 10px;
    .content-description {
    }

    .content-date {
        text-align: right;
        border-bottom: 1px solid #000;
    }
}

.content-versioning-upcoming {
    background-color: #e6e6e6;

    .content-description {
        border-bottom: 1px solid #000;
    }
}
</style>



// WEBPACK FOOTER //
// Versionings.vue?b1cd43fa